import script from "./WechatOpenBrowserMask.vue?vue&type=script&setup=true&lang=ts"
export * from "./WechatOpenBrowserMask.vue?vue&type=script&setup=true&lang=ts"

import "./WechatOpenBrowserMask.vue?vue&type=style&index=0&id=2639db12&scoped=true&lang=css"

import exportComponent from "D:\\laoyou\\rez-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2639db12"]])

export default __exports__